import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import ButtonSpiner from '../buttonSpinner';

import './form.scss';

const LoginForm = ({
  isOpen,
  submitForm,
  setIsOpen,
  setIsRegoFormModalOpen,
  isLoginLoading,
  setIsLoginLoading,
}) => {
  const {
    formState: { errors, isValid, isDirty },
    handleSubmit,
    register,
    reset,
    watch,
    setError,
  } = useForm({
    mode: 'onChange',
  });

  const onSubmit = handleSubmit(async data => {
    setIsLoginLoading(true);
    try {
      await submitForm(data);
      reset();
      setIsOpen(false);
    } catch (error) {
      setError('form', {
        type: 'manual',
        message: 'Invalid username or password',
      });
    } finally {
      setIsLoginLoading(false);
    }
  });

  return (
    <Modal show={isOpen}>
      <Form onSubmit={onSubmit} className="cdh-form login-form">
        <Modal.Header>
          <Modal.Title>Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errors.form && errors.form.message && (
            <div className="invalid-feedback">{errors.form.message}</div>
          )}
          <Form.Group className="mb-3">
            <Form.Label>Username</Form.Label>
            <Form.Control
              placeholder="username"
              {...register('username', {
                required: 'Username is required',
              })}
            />
            {errors.username && errors.username.message && (
              <div className="invalid-feedback">{errors.username.message}</div>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
              name="password"
              type="password"
              placeholder="password"
              {...register('password', {
                required: 'Password is required',
              })}
            />
            {errors.password && errors.password.message && (
              <div className="invalid-feedback">{errors.password.message}</div>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <a
            className="rego-link"
            role="button"
            onClick={() => {
              reset();
              setIsOpen(false);
              setIsRegoFormModalOpen(true);
            }}
          >
            Register
          </a>
          <Button
            variant="outline"
            className="btn-outline-secondary site-btn cancel-btn"
            onClick={() => {
              reset();
              setIsOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={!isValid && isDirty}
            variant="primary"
            type="submit"
            className="site-btn"
          >
            {isLoginLoading ? (
              <>
                <ButtonSpiner />
                {'Logining...'}
              </>
            ) : (
              'Login'
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default LoginForm;
